/*
 * SGD DISPLAY — Singapore visitors see prices in SGD (display only).
 * Added 2026-09-23. See snippets/sgd-display.liquid for the full note and how to remove.
 *
 * What it does
 *   1. Decides the mode: manual choice (cookie) > Shopify geo-detection (cookie, 1 day)
 *      > country picked in the theme's country selector > MYR.
 *   2. Rewrites every "RM1,234.56" text node to "S$xxx.xx" at the fixed rate, wrapping it
 *      in <span class="sgd-price" data-myr="…" data-sgd="…"> so it can be switched back.
 *   3. Watches the DOM so prices added later (cart drawer, variant change, quick-add,
 *      infinite scroll) are converted too.
 *   4. Shows a small RM / S$ toggle and a checkout notice ("charged in MYR") for SG visitors.
 *
 * What it never touches: checkout, inputs, scripts/styles, the price-range filter,
 * anything inside [data-sgd-ignore].
 */
(function () {
  'use strict';

  var cfgEl = document.getElementById('sgd-display-config');
  if (!cfgEl) return;
  var cfg;
  try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { return; }

  var rate = parseFloat(String(cfg.rate || '').replace(',', '.'));
  if (!(rate > 0)) return;

  /* ---------- money format → regex ---------- */
  var fmt = String(cfg.moneyFormat || 'RM{{amount}}');
  var m = fmt.match(/^([\s\S]*?)\{\{\s*([a-z_]+)\s*\}\}([\s\S]*)$/);
  var prefix = m ? m[1] : 'RM';
  var suffix = m ? m[3] : '';
  var commaDecimal = m ? /comma_separator/.test(m[2]) : false;
  var esc = function (s) { return s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); };
  var NUM = commaDecimal
    ? '(\\d{1,3}(?:\\.\\d{3})+|\\d+)(?:,(\\d{1,2}))?'
    : '(\\d{1,3}(?:,\\d{3})+|\\d+)(?:\\.(\\d{1,2}))?';
  var pattern;
  if (prefix.trim()) {
    pattern = '(^|[^A-Za-z0-9])' + esc(prefix) + NUM + '(?:' + esc(suffix) + ')?(?:\\s?MYR)?(?![0-9])';
  } else {
    pattern = '(^|[^A-Za-z0-9])' + NUM + esc(suffix) + '(?:\\s?MYR)?(?![0-9])';
  }
  var PRICE_RE = new RegExp(pattern, 'g');
  var QUICK_RE = new RegExp(prefix.trim() ? esc(prefix) + '\\d' : '\\d' + esc(suffix));

  /* ---------- conversion ---------- */
  function toCents(intPart, decPart) {
    var whole = parseInt(intPart.replace(/[.,]/g, ''), 10);
    var dec = decPart ? parseInt((decPart + '0').slice(0, 2), 10) : 0;
    return whole * 100 + dec;
  }
  function roundSgd(v) {
    if (cfg.rounding === '90') {
      var r = Math.ceil(v - 0.9 - 1e-9) + 0.9;
      return r < 0.9 ? 0.9 : r;
    }
    if (cfg.rounding === 'whole') return Math.ceil(v - 1e-9);
    return Math.round(v * 100) / 100;
  }
  function fmtNumber(v) {
    var parts = v.toFixed(2).split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return parts.join('.');
  }
  function myrCentsToSgdText(cents) {
    return 'S$' + fmtNumber(roundSgd(cents / 100 / rate));
  }
  function myrCentsToMyrText(cents) {
    var v = fmtNumber(cents / 100);
    if (commaDecimal) v = v.replace(/,/g, '\u0000').replace('.', ',').replace(/\u0000/g, '.');
    return prefix + v + suffix;
  }

  /* ---------- state ---------- */
  var MANUAL = 'sgd_display';   // 'sgd' | 'myr'  (30 days)
  var DETECT = 'sgd_detected';  // 'SG' | country code (1 day)
  function getCookie(n) {
    var r = document.cookie.match('(?:^|; )' + n + '=([^;]*)');
    return r ? decodeURIComponent(r[1]) : null;
  }
  function setCookie(n, v, days) {
    document.cookie = n + '=' + encodeURIComponent(v) + '; path=/; max-age=' + (days * 86400) + '; SameSite=Lax';
  }

  var manual = getCookie(MANUAL);
  var detected = getCookie(DETECT);
  var isSgVisitor = detected === 'SG' || cfg.countrySelected === 'SG' || !!manual;
  var mode = manual || (isSgVisitor ? 'sgd' : 'myr');

  /* ---------- DOM rewrite ---------- */
  var SKIP_TAGS = { SCRIPT: 1, STYLE: 1, NOSCRIPT: 1, TEXTAREA: 1, INPUT: 1, TEMPLATE: 1, CODE: 1, PRE: 1 };
  var IGNORE_SEL = '[data-sgd-ignore], .sgd-price, .sgd-toggle, .sgd-notice, price-range, .facets__price';
  var muting = false;

  function ignored(el) {
    for (; el && el.nodeType === 1; el = el.parentNode) {
      if (SKIP_TAGS[el.tagName]) return true;
      if (el.matches && el.matches(IGNORE_SEL)) return true;
    }
    return false;
  }

  function wrapTextNode(node) {
    var text = node.nodeValue;
    if (!QUICK_RE.test(text)) return;
    PRICE_RE.lastIndex = 0;
    var frag = document.createDocumentFragment();
    var last = 0, hit = false, r;
    while ((r = PRICE_RE.exec(text))) {
      hit = true;
      var lead = r[1] || '';
      var start = r.index + lead.length;
      if (start > last) frag.appendChild(document.createTextNode(text.slice(last, start)));
      var cents = toCents(r[2], r[3]);
      var span = document.createElement('span');
      span.className = 'sgd-price';
      span.setAttribute('data-myr', text.slice(start, PRICE_RE.lastIndex));
      span.setAttribute('data-sgd', myrCentsToSgdText(cents));
      paint(span);
      frag.appendChild(span);
      last = PRICE_RE.lastIndex;
    }
    if (!hit) return;
    if (last < text.length) frag.appendChild(document.createTextNode(text.slice(last)));
    node.parentNode.replaceChild(frag, node);
  }

  function processRoot(root) {
    if (!root) return;
    if (root.nodeType === 3) {
      if (!ignored(root.parentNode)) wrapTextNode(root);
      return;
    }
    if (root.nodeType !== 1 && root.nodeType !== 9 && root.nodeType !== 11) return;
    if (root.nodeType === 1 && ignored(root)) return;
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode: function (n) {
        return QUICK_RE.test(n.nodeValue) && !ignored(n.parentNode) ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_REJECT;
      }
    });
    var nodes = [], n;
    while ((n = walker.nextNode())) nodes.push(n);
    nodes.forEach(wrapTextNode);
  }

  /* Paints one price span. In SGD mode the MYR original can be kept as a small
     secondary line — Appendix A.4 of the market-entry report recommends never hiding the
     currency the card is actually charged in. Off by default; tick-box in Theme settings. */
  function paint(span) {
    var myr = span.getAttribute('data-myr');
    var sgd = span.getAttribute('data-sgd');
    if (mode !== 'sgd') { span.textContent = myr; return; }
    if (!cfg.showMyrSecondary) { span.textContent = sgd; return; }
    span.textContent = '';
    span.appendChild(document.createTextNode(sgd));
    var sub = document.createElement('span');
    sub.className = 'sgd-price__myr';
    sub.textContent = myr;
    span.appendChild(sub);
  }

  function applyMode() {
    muting = true;
    var spans = document.querySelectorAll('.sgd-price');
    for (var i = 0; i < spans.length; i++) paint(spans[i]);
    if (mode === 'sgd') processRoot(document.body || document.documentElement);
    document.documentElement.setAttribute('data-sgd-mode', mode);
    renderNotices();
    renderToggle();
    muting = false;
  }

  function setMode(next, remember) {
    mode = next === 'sgd' ? 'sgd' : 'myr';
    if (remember) setCookie(MANUAL, mode, 30);
    isSgVisitor = true;
    applyMode();
  }

  /* ---------- observer (dynamic content) ---------- */
  var pending = [];
  var scheduled = false;
  function flush() {
    scheduled = false;
    if (muting) { pending = []; return; }
    muting = true;
    var list = pending; pending = [];
    for (var i = 0; i < list.length; i++) {
      var node = list[i];
      if (!node.isConnected) continue;
      if (mode === 'sgd') processRoot(node);
      if (node.nodeType === 1 && (node.matches('[name="checkout"]') || node.querySelector('[name="checkout"]'))) renderNotices();
    }
    muting = false;
  }
  var observer = new MutationObserver(function (records) {
    if (muting) return;
    for (var i = 0; i < records.length; i++) {
      var rec = records[i];
      if (rec.type === 'characterData') {
        pending.push(rec.target);
      } else {
        for (var j = 0; j < rec.addedNodes.length; j++) pending.push(rec.addedNodes[j]);
      }
    }
    if (pending.length && !scheduled) {
      scheduled = true;
      (window.requestAnimationFrame || setTimeout)(flush);
    }
  });
  observer.observe(document.documentElement, { childList: true, subtree: true, characterData: true });

  /* ---------- checkout notice ---------- */
  var cartCents = typeof cfg.cartTotalCents === 'number' ? cfg.cartTotalCents : null;
  var cartFetchTimer = null;

  function noticeText() {
    var t = String(cfg.notice || '');
    t = t.replace(/\[rate\]/g, String(rate));
    t = t.replace(/\[myr_total\]/g, cartCents == null ? '' : myrCentsToMyrText(cartCents));
    t = t.replace(/\[sgd_total\]/g, cartCents == null ? '' : myrCentsToSgdText(cartCents));
    return t.replace(/\(\s*\)/g, '').replace(/\s{2,}/g, ' ').trim();
  }

  function renderNotices() {
    var buttons = document.querySelectorAll('[name="checkout"]');
    for (var i = 0; i < buttons.length; i++) {
      var btn = buttons[i];
      var prev = btn.previousElementSibling;
      var existing = prev && prev.classList.contains('sgd-notice') ? prev : null;
      if (mode !== 'sgd' || !cfg.notice) {
        if (existing) existing.remove();
        continue;
      }
      if (!existing) {
        existing = document.createElement('p');
        existing.className = 'sgd-notice';
        existing.setAttribute('role', 'note');
        btn.parentNode.insertBefore(existing, btn);
      }
      var text = noticeText();
      if (existing.textContent !== text) existing.textContent = text;
    }
    if (mode === 'sgd' && buttons.length) refreshCartTotal();
  }

  function refreshCartTotal() {
    if (cartFetchTimer) return;
    cartFetchTimer = setTimeout(function () {
      cartFetchTimer = null;
      fetch('/cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (cart) {
          if (!cart || typeof cart.total_price !== 'number' || cart.total_price === cartCents) return;
          cartCents = cart.total_price;
          muting = true;
          var notes = document.querySelectorAll('.sgd-notice');
          var text = noticeText();
          for (var i = 0; i < notes.length; i++) notes[i].textContent = text;
          muting = false;
        })
        .catch(function () {});
    }, 300);
  }

  /* ---------- toggle ---------- */
  var toggleEl = null;
  function renderToggle() {
    if (!cfg.showToggle || !isSgVisitor) { if (toggleEl) { toggleEl.remove(); toggleEl = null; } return; }
    if (!document.body) return;
    if (!toggleEl) {
      toggleEl = document.createElement('div');
      toggleEl.className = 'sgd-toggle sgd-toggle--' + (cfg.togglePosition === 'right' ? 'right' : 'left');
      toggleEl.setAttribute('role', 'group');
      toggleEl.setAttribute('aria-label', 'Display currency');
      toggleEl.innerHTML =
        '<button type="button" class="sgd-toggle__btn" data-sgd-set="myr">RM</button>' +
        '<button type="button" class="sgd-toggle__btn" data-sgd-set="sgd">S$</button>';
      toggleEl.addEventListener('click', function (e) {
        var b = e.target.closest('[data-sgd-set]');
        if (b) setMode(b.getAttribute('data-sgd-set'), true);
      });
      document.body.appendChild(toggleEl);
    }
    var btns = toggleEl.querySelectorAll('[data-sgd-set]');
    for (var i = 0; i < btns.length; i++) {
      btns[i].setAttribute('aria-pressed', btns[i].getAttribute('data-sgd-set') === mode ? 'true' : 'false');
    }
  }

  /* ---------- geo detection (Shopify's own endpoint, no third party) ---------- */
  function detect() {
    if (!cfg.autoDetect || manual || detected || cfg.countrySelected === 'SG') return;
    fetch('/browsing_context_suggestions.json?country%5Benabled%5D=true', {
      headers: { Accept: 'application/json' }, credentials: 'same-origin'
    })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (data) {
        var code = data && data.detected_values && data.detected_values.country && data.detected_values.country.handle;
        if (!code) return;
        detected = String(code).toUpperCase();
        setCookie(DETECT, detected, 1);
        if (detected === 'SG' && !getCookie(MANUAL)) {
          isSgVisitor = true;
          setMode('sgd', false);
        }
      })
      .catch(function () {});
  }

  /* ---------- boot ---------- */
  function ready(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  }
  document.documentElement.setAttribute('data-sgd-mode', mode);
  ready(function () {
    applyMode();
    detect();
  });

  window.SGDDisplay = {
    getMode: function () { return mode; },
    setMode: function (m) { setMode(m, true); },
    rate: rate
  };
})();
